export enum EBookCallStatus {
    idle = 'IDLE',
    pending = 'PENDING',
    requested = 'REQUESTED',
}

export interface IBookCall {
    status: EBookCallStatus;
}
